module.exports = __webpack_public_path__ + "img/eyes_female_average.837d9906.png";